import WrapperService from '@/modules/core/services/wrapper-service';
import {createPageableParams} from '@/modules/core/services/table-utils';

const settingsServiceName = "Tag-Service: ";
const TAG_API_URL = process.env.VUE_APP_ROOT_API + '/api/v1/display/tag';

export default class TagService {

    static async readAllTagsPaginated(page, size, search, sort, sortAsc, successF, errorF) {
        let params = createPageableParams(page, size, search, sort, sortAsc, successF, errorF, ['name'], ['name']);
        await WrapperService.get(TAG_API_URL + '/page?' + params, null, settingsServiceName, successF, errorF);
    }

    static async saveTag(tag, successF, errorF) {
        if (typeof tag.id === 'undefined' || tag.id === null) {
            await WrapperService.post(TAG_API_URL, tag, settingsServiceName, successF, errorF);
        } else {
            await WrapperService.put(TAG_API_URL + '/' + tag.id, tag, settingsServiceName, successF, errorF);
        }
    }

    static async deleteTag(id, successF, errorF) {
        await WrapperService.delete(TAG_API_URL + '/' + id, null, settingsServiceName, successF, errorF);
    }

    static async readFromAPI(id, successF, errorF) {
        await WrapperService.get(TAG_API_URL + "/" + id, null, settingsServiceName, successF, errorF);
    }
}